/**
 * Stable `data-testid` values for VideoCallMeet UI (tests, e2e, automation).
 * Prefer importing from here rather than duplicating string literals.
 */
export const VIDEO_CALL_MEET_TEST_IDS = {
  root: 'video-call-meet-root',
  header: 'video-call-meet-header',
  networkQuality: 'video-call-meet-network-quality',
  errorMessage: 'video-call-meet-error',
  body: 'video-call-meet-body',
  remoteNotice: 'video-call-meet-remote-notice',
  layoutStage: 'video-call-meet-layout-stage',
  mainGrid: 'video-call-meet-main-grid',
  waitingPlaceholder: 'video-call-meet-waiting-placeholder',
  localTile: 'video-call-meet-local-tile',
  localVideo: 'video-call-meet-local-video',
  localVideoOff: 'video-call-meet-local-video-off',
  localLabel: 'video-call-meet-local-label',
  controls: 'video-call-meet-controls',
  controlMic: 'video-call-meet-control-mic',
  controlVideo: 'video-call-meet-control-video',
  controlDevices: 'video-call-meet-control-devices',
  controlBackground: 'video-call-meet-control-background',
  controlFullscreen: 'video-call-meet-control-fullscreen',
  controlEnd: 'video-call-meet-control-end',
  devicePanel: 'video-call-meet-device-panel',
  deviceSectionTitle: 'video-call-meet-device-section-title',
  deviceCameraLabel: 'video-call-meet-device-camera-label',
  deviceCameraSelect: 'video-call-meet-device-camera-select',
  deviceMicLabel: 'video-call-meet-device-mic-label',
  deviceMicSelect: 'video-call-meet-device-mic-select',
  deviceClose: 'video-call-meet-device-close',
  backgroundPanel: 'video-call-meet-background-panel',
  backgroundSectionTitle: 'video-call-meet-background-section-title',
  backgroundNone: 'video-call-meet-background-none',
  backgroundBlur: 'video-call-meet-background-blur',
  backgroundImageGrid: 'video-call-meet-background-image-grid',
  backgroundClose: 'video-call-meet-background-close',
} as const

export function videoCallMeetRemoteTileTestId(uid: string): string {
  return `video-call-meet-remote-tile-${uid}`
}

export function videoCallMeetRemoteVideoTestId(uid: string): string {
  return `video-call-meet-remote-video-${uid}`
}

export function videoCallMeetRemoteVideoOffTestId(uid: string): string {
  return `video-call-meet-remote-video-off-${uid}`
}

export function videoCallMeetRemoteLabelTestId(uid: string): string {
  return `video-call-meet-remote-label-${uid}`
}

export function videoCallMeetBackgroundImageTestId(index: number): string {
  return `video-call-meet-background-image-${index}`
}
